import { css } from 'linaria';

export const signSectionPanelWrapper = css`
  width: 100%;
`;

export const signSectionPanel = css`
  display: flex;
  align-items: center;
  width: 100%;
  padding: 8px 0;

  @media (--only-tablet) {
    flex-direction: column;
    row-gap: 24px;
  }

  @media (--only-mobile) {
    display: none;
  }
`;

export const signSectionPanelTextWrapper = css`
  display: flex;
  column-gap: 24px;

  @media (--only-tablet) {
    justify-content: flex-start;
    width: 100%;
  }

  @media (--only-mobile) {
    display: none;
  }
`;

export const signSectionPanelText = css`
  white-space: break-spaces;
`;

export const signSectionPanelButtons = css`
  display: flex;
  margin-left: auto;
  column-gap: 24px;

  @media (--to-desktop) {
    && a {
      padding: 10px 20px;
    }
  }
`;

export const signSectionPanelMobileButton = css`
  @media (--from-tablet) {
    display: none;
  }
`;
